import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

export function getCampaignInvitation(invitationId) {
  const client = JSONApiClient();

  return client.get('campaignInvitation', invitationId, {})
    .then(response => response);
}

export function deleteCampaignInvitation(campaignInvitation) {
  return campaignInvitation.delete()
    .then(response => response);
}

export function getCampaignInvitationAxios(invitationId) {
  const axiosService = new AxiosService(process.env.REACT_APP_GET_CAMPAIGN_INVITATION_API, process.env.REACT_APP_API_TIMEOUT, {});

  // Get user information from invite table
  return axiosService.get(`/${invitationId}`, {})
    .then(response => response.data.body);
}

export function processCampaignInvitation(invitationId) {
  const axiosService = new AxiosService(process.env.REACT_APP_CREATE_CAMPAIGN_PERMISSION_API, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  // Attempt to process campaign invite into permission
  return axiosService.post('/', {
    data: {
      type: 'campaignPermission',
      attributes: { shortId: invitationId },
    },
  })
    .then(response => response);
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/campaign-invitations.js
 **/